/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import { usePlugImageContext } from "../../../../../context/plugImage/PlugImageContext";
import { useCountryContext } from "../../../../../context/country/countryContext/CountryContext";
import { useTradeOrganizationContext } from "../../../../../context/tradeOrganization/TradeOrganizationContext";
import { useContinentRegionContext } from "../../../../../context/continentRegion/context/ContinentRegionContext";
import {
  GoBack,
  Select,
  TextArea,
  SubTitle,
  MyMessage,
  InputField,
  MyActionButton,
  SelectInput,
  MyButton,
} from "../../../component/Component";
import { useParams } from "react-router-dom";
import { defaultImage } from "../../../../../middlewares/libraries/imageKit/ImageKit";
import { ImageKitUpload } from "../../../../../middlewares/libraries/imageKit/ImageKitLibrary";
import { FOLDERS } from "../../../../doseeData/utils/Utils";
import BestTimeToVisit from "../../../component/BestTimeToVisit";
import TradeOrganizationCard from "./TradeOrganizationCard";
import PlugImageCard from "./PlugImageCard";
import RegionalBlocksCard from "./RegionalBlocksCard";
import { useRegionalBlocksContext } from "../../../../../context/regionalBlocks/RegionalBlocksContext";
import GenerateDescription from "../../../../doseeData/utils/GenerateDescription";

const countriesRoute = "/countries";

const Edit = () => {
  const { regions, fetchRegions } = useContinentRegionContext();
  const { updateCountry, country, fetchCountry } = useCountryContext();
  const { plugImage, fetchPlugImages } = usePlugImageContext();
  const { regionalBlocks, fetchRegionalBlocks } = useRegionalBlocksContext();
  const { tradeOrganization, fetchTradeOrganizations } =
    useTradeOrganizationContext();

  const { country_id } = useParams();

  const [continentRegion, setContinentRegion] = useState([]);

  const [localPlugImages, setLocalPlugImages] = useState(null);
  const [localTradeOrganizations, setLocalTradeOrganizations] = useState(null);
  const [localRegionalBlocks, setLocalRegionalBlocks] = useState(null);
  const countryAudioURL = "no-audio";
  const [country_gdp, set_country_gdp] = useState(null);
  const [country_name, set_country_name] = useState(null);
  const [country_slug, set_country_slug] = useState(null);
  const [country_president, set_country_president] = useState(null);
  const [country_neighbours, set_country_neighbours] = useState(null);
  const [country_population, set_country_population] = useState(null);
  const [continent_region_id, set_continent_region_id] = useState(1);
  const [country_capital_city, set_country_capital_city] = useState(null);
  const [country_national_symbol, set_country_national_symbol] = useState(null);
  const [country_div_structure, set_country_div_structure] = useState(null);
  const [internet_users, set_internet_users] = useState(null);
  const [number_of_phones, set_number_of_phones] = useState(null);
  const [top_level_domain, set_top_level_domain] = useState(null);
  const [internet_providers, set_internet_providers] = useState(null);
  const [country_description, set_country_description] = useState(null);
  const [country_driving_side, set_country_driving_side] = useState("left");
  const [tourism, set_tourism] = useState("safe");
  const [safety_indicator, set_safety_indicator] = useState("safe");
  const [thumbnail, setThumbnail] = useState("none");
  const [thumbnailId, setThumbnailId] = useState("none");
  const [thumbnailFlag, setThumbnailFlag] = useState(null);
  const [thumbnailIdFlag, setThumbnailIdFlag] = useState(null);
  const [voltage, set_voltage] = useState(null);
  const [plug_note, set_plug_note] = useState(null);
  const [frequency, set_frequency] = useState(null);
  const [plug_standard, set_plug_standard] = useState(null);
  const [residential_voltage, set_residential_voltage] = useState(null);
  const [three_phase_voltage, set_three_phase_voltage] = useState(null);
  const [tiktok, set_tiktok] = useState("none");
  const [twitter, set_twitter] = useState("none");
  const [website, set_website] = useState("none");
  const [youtube, set_youtube] = useState("none");
  const [facebook, set_facebook] = useState("none");
  const [instagram, set_instagram] = useState("none");
  const [pinterest, set_pinterest] = useState("none");
  const [ease_of_doing_business_global, set_ease_of_doing_business_global] =
    useState(null);
  const [ease_of_doing_business_regional, set_ease_of_doing_business_regional] =
    useState(null);
  const [
    ease_of_doing_business_continent,
    set_ease_of_doing_business_continent,
  ] = useState(null);
  const [exports_goods, set_exports_goods] = useState(null);
  const [exports_increase, set_exports_increase] = useState(null);
  const [main_export_partners, set_main_export_partners] = useState(null);
  const [imports_goods, set_imports_goods] = useState(null);
  const [imports_increase, set_imports_increase] = useState(null);
  const [main_import_partners, set_main_import_partners] = useState(null);
  const [iso_2, set_iso_2] = useState(null);
  const [iso_3, set_iso_3] = useState(null);
  const [zip_code, set_zip_code] = useState(null);
  const [phone_code, set_phone_code] = useState(null);
  const [country_code, set_country_code] = useState(null);
  const [alpha_code_2, set_alpha_code_2] = useState(null);
  const [alpha_code_3, set_alpha_code_3] = useState(null);
  const [map, set_map] = useState(null);
  const [area, set_area] = useState(null);
  const [latitude, set_latitude] = useState(null);
  const [timezone, set_timezone] = useState(null);
  const [longitude, set_longitude] = useState(null);
  const [geographical_id, set_geographical_id] = useState(null);
  const [currency_name, set_currency_name] = useState(null);
  const [currency_symbol, set_currency_symbol] = useState(null);
  const [convertion_rate_to_usd, set_convertion_rate_to_usd] = useState(null);
  const [transport_name, set_transport_name] = useState(null);
  const [stock_market_name, set_stock_market_name] = useState(null);
  const [stock_market_info, set_stock_market_info] = useState(null);
  const [stock_market_index, set_stock_market_index] = useState(null);
  const [countryStatus, setCountryStatus] = useState(null);

  const [trades, setTrades] = useState([]);
  const [tradesID, setTradesID] = useState([]);
  const [blocks, setBlocks] = useState([]);
  const [blocksID, setBlocksID] = useState([]);
  const [plugs, setPlugs] = useState([]);
  const [plugsID, setPlugsID] = useState([]);

  const [isPlugChanged, setIsPlugChanges] = useState(0);
  const [isPTradeChanged, setIsTradeChanges] = useState(0);
  const [isBlockChanged, setIsBlockChanges] = useState(0);
  const [error, setError] = useState(false);
  const [message, setErrorMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [bestTime, setBestTime] = useState([]);
  const [showDescriptionModal, setShowDescriptionModal] = useState(null);

  const cleanFields = () => {
    setLoading(false);
    setSuccess(true);
  };

  useEffect(() => {
    if (!country) {
      fetchCountry(country_id);
    } else {
      setThumbnail(country?.thumbnail);
      setThumbnailId(country?.image_cdn_id);
      setThumbnailFlag(country?.flag);
      setThumbnailIdFlag(country?.flag_cdn_id);
      set_country_gdp(country?.gdp);
      set_country_name(country?.name);
      set_country_slug(country?.slug);
      set_country_president(country?.president);
      set_country_neighbours(
        country?.country_neighbour ? String(country?.country_neighbour) : null
      );
      set_country_population(country?.population);
      set_continent_region_id(country?.continent_region_id);
      set_country_capital_city(country?.capital_city);
      set_country_national_symbol(country?.national_symbol);
      set_country_div_structure(
        country?.admin_division_structure
          ? String(country?.admin_division_structure)
          : null
      );
      set_internet_users(country?.internet_users);
      set_number_of_phones(country?.mobile_phone);
      set_top_level_domain(country?.tld);
      set_internet_providers(
        country?.internet_provider ? String(country?.internet_provider) : null
      );
      set_country_description(country?.description);
      set_country_driving_side(country?.driving_side);
      set_tourism(country?.tourism);
      set_safety_indicator(country?.safety_indicator);
      set_voltage(country?.voltage);
      set_plug_note(country?.plug_note);
      set_frequency(country?.frequency);
      set_plug_standard(country?.plug_standard);
      set_residential_voltage(country?.residential_voltage);
      set_three_phase_voltage(country?.three_phase_voltage);
      set_tiktok(country?.tiktok);
      set_twitter(country?.twitter);
      set_website(country?.website);
      set_youtube(country?.youtube);
      set_facebook(country?.facebook);
      set_instagram(country?.instagram);
      set_pinterest(country?.pinterest);
      set_ease_of_doing_business_global(
        country?.ease_of_doing_business_global_ranking
      );
      set_ease_of_doing_business_regional(
        country?.ease_of_doing_business_regional_ranking
      );
      set_ease_of_doing_business_continent(
        country?.ease_of_doing_business_continent_ranking
      );
      set_exports_goods(
        country?.exports_goods ? String(country?.exports_goods) : null
      );
      set_exports_increase(
        country?.exports_increase ? String(country?.exports_increase) : null
      );
      set_main_export_partners(
        country?.main_export_partners
          ? String(country?.main_export_partners)
          : null
      );
      set_imports_goods(
        country?.imports_goods ? String(country?.imports_goods) : null
      );
      set_imports_increase(
        country?.imports_increase ? String(country?.imports_increase) : null
      );
      set_main_import_partners(
        country?.main_import_partners
          ? String(country?.main_import_partners)
          : null
      );
      set_iso_2(country?.iso_2_code);
      set_iso_3(country?.iso_3_code);
      set_zip_code(country?.zip_code);
      set_phone_code(country?.phone_code);
      set_country_code(country?.country_code);
      set_alpha_code_2(country?.alpha_code_2);
      set_alpha_code_3(country?.alpha_code_3);
      set_map(country?.map);
      set_area(country?.area);
      set_latitude(country?.latitude);
      set_timezone(country?.time_zone);
      set_longitude(country?.longitude);
      set_geographical_id(country?.geo_id);
      set_currency_name(country?.currency_name);
      set_currency_symbol(country?.currency_symbol);
      set_convertion_rate_to_usd(country?.convertion_rate_to_usd);
      set_transport_name(country?.transportation);
      set_stock_market_name(country?.stock_market_name);
      set_stock_market_info(country?.stock_market_info);
      set_stock_market_index(country?.stock_market_index);
      setTradesID(
        country?.TradeOrganizations?.map((tr) => tr?.trade_organization_id)
      );
      setTrades(country?.TradeOrganizations?.map((tr) => tr?.name));
      setBlocksID(country?.RegionalBlocks?.map((tr) => tr?.regional_blocks_id));
      setBlocks(country?.RegionalBlocks?.map((tr) => tr?.name));
      setPlugsID(country?.PlugImages?.map((tr) => tr?.plug_image_id));
      setPlugs(country?.PlugImages?.map((tr) => tr?.type));
      setCountryStatus(country?.status);
      setBestTime(
        country?.best_time_to_visit ? country?.best_time_to_visit : []
      );
    }

    if (!regions) {
      fetchRegions();
    } else {
      const this_region_array = [];
      regions.map((region) =>
        this_region_array.push({
          name: region?.name,
          id: region?.continent_region_id,
        })
      );
      setContinentRegion(this_region_array);
    }

    if (!tradeOrganization) {
      fetchTradeOrganizations();
    } else {
      setLocalTradeOrganizations(tradeOrganization);
    }

    if (!regionalBlocks) {
      fetchRegionalBlocks(1, 50);
    } else {
      setLocalRegionalBlocks(regionalBlocks);
    }

    if (!plugImage) {
      fetchPlugImages();
    } else {
      setLocalPlugImages(plugImage);
    }
  }, [country, regions, tradeOrganization, plugImage, regionalBlocks]);

  const responses = (isError, message) => {
    setError(isError);
    setLoading(false);
    setSuccess(!isError);
    setErrorMessage(message);
  };

  const sendAddCountryRequest = async (e) => {
    e.preventDefault();
    setLoading(true);
    if (!thumbnail || !thumbnailFlag) {
      setLoading(false);
      responses(true, "Image or Flag Missing");
    } else {
      await sendDBRequest();
    }
  };

  const sendDBRequest = async () => {
    const Country = {
      continent_region_id: continent_region_id,
      name: country_name,
      slug: country_slug?.toLowerCase()?.replace(/\s/g, "_"),
      thumbnail: thumbnail ? thumbnail : defaultImage,
      image_cdn_id: thumbnailId ? thumbnailId : "...",
      admin_division_structure: country_div_structure || "...",
      flag: thumbnailFlag ? thumbnailFlag : defaultImage,
      flag_cdn_id: thumbnailIdFlag ? thumbnailIdFlag : "...",
      president: country_president ? country_president : "...",
      national_symbol: country_national_symbol || "...",
      country_neighbour: country_neighbours || "...",
      population: country_population,
      capital_city: country_capital_city || "...",
      tld: top_level_domain,
      internet_provider: internet_providers || "...",
      internet_users: internet_users,
      mobile_phone: number_of_phones,
      audio: countryAudioURL,
      gdp: country_gdp,
      driving_side: country_driving_side,
      tourism: tourism,
      safety_indicator: safety_indicator,
      plug_type: "...",
      voltage: voltage,
      plug_standard: plug_standard,
      residential_voltage: residential_voltage,
      three_phase_voltage: three_phase_voltage,
      frequency: frequency,
      plug_note: plug_note,
      youtube: youtube,
      facebook: facebook,
      twitter: twitter,
      instagram: instagram,
      pinterest: pinterest,
      tiktok: tiktok,
      website: website,
      description: country_description,
      ease_of_doing_business_regional_ranking: ease_of_doing_business_regional,
      ease_of_doing_business_continent_ranking:
        ease_of_doing_business_continent,
      ease_of_doing_business_global_ranking: ease_of_doing_business_global,
      exports_increase: exports_increase || "...",
      exports_goods: exports_goods || "...",
      main_export_partners: main_export_partners || "...",
      imports_increase: imports_increase || "...",
      imports_goods: imports_goods || "...",
      main_import_partners: main_import_partners || "...",
      country_code: country_code,
      zip_code: zip_code,
      phone_code: phone_code,
      alpha_code_2: alpha_code_2,
      alpha_code_3: alpha_code_3,
      iso_2_code: iso_2,
      iso_3_code: iso_3,
      currency_name: currency_name,
      currency_symbol: currency_symbol,
      convertion_rate_to_usd: convertion_rate_to_usd,
      transportation: transport_name,
      stock_market_name: stock_market_name,
      stock_market_index: stock_market_index,
      stock_market_info: stock_market_info,
      latitude: latitude,
      longitude: longitude,
      area: area,
      geo_id: geographical_id,
      map: map,
      time_zone: timezone,
      plug_images: { status: isPlugChanged, data: plugsID },
      trade_organizations: { status: isPTradeChanged, data: tradesID },
      regional_blocks: { status: isBlockChanged, data: blocksID },
      status: countryStatus,
      best_time_to_visit: bestTime?.length > 0 ? String(bestTime) : null,
    };

    const { message, status } = await updateCountry(country_id, Country);
    if (status === 200) {
      cleanFields();
      responses(false, message);
    } else {
      responses(true, message);
    }
  };

  return (
    <div className="p-4 h-full overflow-y-auto rounded-b-xl bg-gray-50">
      <GoBack props={{ route: countriesRoute }} />

      {showDescriptionModal ? (
        <GenerateDescription
          setDescription={set_country_description}
          setShowDescriptionModal={setShowDescriptionModal}
        />
      ) : null}

      <form onSubmit={sendAddCountryRequest}>
        {/* Toast / Alerts */}
        <div className="mx-auto max-w-7xl">
          <MyMessage
            error={error}
            message={message}
            success={success}
            onExpired={() => {
              setError(false);
              setSuccess(false);
            }}
            onClick={() => {
              setError(false);
              setSuccess(false);
              setErrorMessage("");
            }}
          />
        </div>

        <div className="mx-auto max-w-7xl space-y-6">
          {/* MEDIA */}
          <section className="rounded-2xl border border-gray-200 bg-white shadow-sm">
            <div className="flex items-center justify-between border-b px-5 py-4">
              <h3 className="text-sm font-semibold text-gray-900">Country Media</h3>
              <span className="text-[11px] text-gray-500">JPG/PNG/WEBP • Min 800×600</span>
            </div>
            <div className="grid grid-cols-1 gap-4 p-5 md:grid-cols-2">
              <ImageKitUpload
                thumbnail={thumbnail}
                thumbnailId={thumbnailId}
                setThumbnail={setThumbnail}
                setThumbnailId={setThumbnailId}
                folder={FOLDERS.COUNTRIES}
              />
              <ImageKitUpload
                thumbnail={thumbnailFlag}
                thumbnailId={thumbnailIdFlag}
                setThumbnail={setThumbnailFlag}
                setThumbnailId={setThumbnailIdFlag}
                folder={FOLDERS.COUNTRIES}
              />
            </div>
          </section>

          {/* CORE DETAILS */}
          <section className="rounded-2xl border border-gray-200 bg-white shadow-sm">
            <div className="border-b px-5 py-4">
              <h3 className="text-sm font-semibold text-gray-900">Country Details</h3>
              <p className="mt-1 text-[11px] text-gray-600">
                Core information used across listings and search.
              </p>
            </div>
            <div className="p-5 space-y-5">
              {/* Best time */}
              <div>
                <p className="text-xs font-semibold text-gray-800 mb-2">
                  Best Time To Visit
                </p>
                <BestTimeToVisit bestTime={bestTime} setBestTime={setBestTime} />
              </div>

              <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
                <Select
                  props={{
                    id: "continent_region",
                    title: "Continent Region",
                    preselect:
                      continentRegion.length > 0 &&
                        country !== null &&
                        country !== undefined
                        ? continentRegion.filter(
                          (region) => region?.id === country?.continent_region_id
                        )
                        : null,
                    option:
                      continentRegion !== null && continentRegion !== undefined
                        ? continentRegion.map((region) => region?.name)
                        : [],
                    onChange: (e) => {
                      set_continent_region_id(
                        regions[e.target.selectedIndex].continent_region_id
                      );
                      setError(null);
                      setSuccess(null);
                    },
                  }}
                />
                <InputField
                  props={{
                    id: "name",
                    title: "Title",
                    type: "text",
                    value: country_name ? country_name : "",
                    onChange: (e) => {
                      set_country_name(e.target.value);
                      setError(null);
                      setSuccess(null);
                    },
                  }}
                />
                <InputField
                  props={{
                    id: "president",
                    title: "President",
                    type: "text",
                    value: country_president ? country_president : "",
                    onChange: (e) => {
                      set_country_president(e.target.value);
                      setError(null);
                      setSuccess(null);
                    },
                  }}
                />
                <InputField
                  props={{
                    id: "national_symbol",
                    title: "National Symbol",
                    type: "text",
                    value: country_national_symbol ? country_national_symbol : "",
                    onChange: (e) => {
                      set_country_national_symbol(e.target.value);
                      setError(null);
                      setSuccess(null);
                    },
                  }}
                />
                <InputField
                  props={{
                    id: "country_neighbour",
                    title: "Neighboring Countries (comma separated)",
                    type: "text",
                    value: country_neighbours ? country_neighbours : "",
                    onChange: (e) => {
                      set_country_neighbours(e.target.value);
                      setError(null);
                      setSuccess(null);
                    },
                  }}
                />
                <InputField
                  props={{
                    id: "population",
                    title: "Population",
                    type: "number",
                    value: country_population ? country_population : "",
                    onChange: (e) => {
                      set_country_population(e.target.value);
                      setError(null);
                      setSuccess(null);
                    },
                  }}
                />
                <InputField
                  props={{
                    id: "gdp",
                    title: "GDP",
                    type: "number",
                    value: country_gdp ? country_gdp : "",
                    onChange: (e) => {
                      set_country_gdp(e.target.value);
                      setError(null);
                      setSuccess(null);
                    },
                  }}
                />
                <InputField
                  props={{
                    id: "capital_city",
                    title: "Capital City",
                    type: "text",
                    value: country_capital_city ? country_capital_city : "",
                    onChange: (e) => {
                      set_country_capital_city(e.target.value);
                      setError(null);
                      setSuccess(null);
                    },
                  }}
                />
                <InputField
                  props={{
                    id: "administrative_division_structure",
                    title: "Administrative Division Structure",
                    type: "text",
                    value: country_div_structure ? country_div_structure : "",
                    onChange: (e) => {
                      set_country_div_structure(e.target.value);
                      setError(null);
                      setSuccess(null);
                    },
                  }}
                />
              </div>
            </div>
          </section>

          {/* DESCRIPTION */}
          <section className="rounded-2xl border border-gray-200 bg-white shadow-sm">
            <div className="flex items-center justify-between border-b px-5 py-4">
              <h3 className="text-sm font-semibold text-gray-900">Country Description</h3>
              <MyButton
                onClick={() => setShowDescriptionModal(true)}
                className="bg-gray-900 hover:bg-gray-800 text-white text-xs font-semibold rounded-lg px-3 py-2"
              >
                Generate Description
              </MyButton>
            </div>
            <div className="p-5">
              <TextArea
                props={{
                  id: "description",
                  title: "Description",
                  type: "text",
                  value: country_description ? country_description : "",
                  onChange: (e) => {
                    set_country_description(e.target.value);
                    setError(null);
                    setSuccess(null);
                  },
                }}
              />
            </div>
          </section>

          {/* CODES & GEO */}
          <section className="rounded-2xl border border-gray-200 bg-white shadow-sm">
            <div className="border-b px-5 py-4">
              <h3 className="text-sm font-semibold text-gray-900">Country Metadata</h3>
              <p className="mt-1 text-[11px] text-gray-600">Codes & Geographical Information</p>
            </div>

            <div className="p-5 space-y-6">
              <div>
                <SubTitle props={{ title: "Codes" }} />
                <div className="mt-3 grid grid-cols-1 gap-4 md:grid-cols-3 lg:grid-cols-4">
                  <InputField props={{ id: "country_code", title: "Country Code", type: "text", value: country_code || "", onChange: (e) => { set_country_code(e.target.value); setError(null); setSuccess(null); } }} />
                  <InputField props={{ id: "zip_code", title: "Zip Code", type: "text", value: zip_code || "", onChange: (e) => { set_zip_code(e.target.value); setError(null); setSuccess(null); } }} />
                  <InputField props={{ id: "phone_code", title: "Phone Code", type: "text", value: phone_code || "", onChange: (e) => { set_phone_code(e.target.value); setError(null); setSuccess(null); } }} />
                  <InputField props={{ id: "alpha_code_2", title: "Alpha Code 2", type: "text", value: alpha_code_2 || "", onChange: (e) => { set_alpha_code_2(e.target.value); setError(null); setSuccess(null); } }} />
                  <InputField props={{ id: "alpha_code_3", title: "Alpha Code 3", type: "text", value: alpha_code_3 || "", onChange: (e) => { set_alpha_code_3(e.target.value); setError(null); setSuccess(null); } }} />
                  <InputField props={{ id: "iso_2", title: "ISO 2", type: "text", value: iso_2 || "", onChange: (e) => { set_iso_2(e.target.value); setError(null); setSuccess(null); } }} />
                  <InputField props={{ id: "iso_3", title: "ISO 3", type: "text", value: iso_3 || "", onChange: (e) => { set_iso_3(e.target.value); setError(null); setSuccess(null); } }} />
                </div>
              </div>

              <div>
                <SubTitle props={{ title: "Geographical Position" }} />
                <div className="mt-3 grid grid-cols-1 gap-4 md:grid-cols-3 lg:grid-cols-4">
                  <InputField props={{ id: "latitude", title: "Latitude", type: "text", value: latitude || "", onChange: (e) => { set_latitude(e.target.value); setError(null); setSuccess(null); } }} />
                  <InputField props={{ id: "longitude", title: "Longitude", type: "text", value: longitude || "", onChange: (e) => { set_longitude(e.target.value); setError(null); setSuccess(null); } }} />
                  <InputField props={{ id: "area", title: "Area", type: "text", value: area || "", onChange: (e) => { set_area(e.target.value); setError(null); setSuccess(null); } }} />
                  <InputField props={{ id: "geo_id", title: "Geographical ID", type: "text", value: geographical_id || "", onChange: (e) => { set_geographical_id(e.target.value); setError(null); setSuccess(null); } }} />
                  <InputField props={{ id: "map", title: "Map", type: "text", value: map || "", onChange: (e) => { set_map(e.target.value); setError(null); setSuccess(null); } }} />
                  <InputField props={{ id: "time_zone", title: "Time Zone", type: "text", value: timezone || "", onChange: (e) => { set_timezone(e.target.value); setError(null); setSuccess(null); } }} />
                </div>
              </div>
            </div>
          </section>

          {/* CURRENCY */}
          <section className="rounded-2xl border border-gray-200 bg-white shadow-sm">
            <div className="border-b px-5 py-4">
              <h3 className="text-sm font-semibold text-gray-900">Currency</h3>
            </div>
            <div className="p-5 grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-3">
              <InputField props={{ id: "currency_name", title: "Name Of Currency", type: "text", value: currency_name || "", onChange: (e) => { set_currency_name(e.target.value); setError(null); setSuccess(null); } }} />
              <InputField props={{ id: "symbol", title: "Symbol Of Currency", type: "text", value: currency_symbol || "", onChange: (e) => { set_currency_symbol(e.target.value); setError(null); setSuccess(null); } }} />
              <InputField props={{ id: "conversion", title: "Conversion Rate To USD", type: "number", value: convertion_rate_to_usd || "", onChange: (e) => { set_convertion_rate_to_usd(e.target.value); setError(null); setSuccess(null); } }} />
            </div>
          </section>

          {/* TRANSPORT */}
          <section className="rounded-2xl border border-gray-200 bg-white shadow-sm">
            <div className="border-b px-5 py-4">
              <h3 className="text-sm font-semibold text-gray-900">Transportation</h3>
            </div>
            <div className="p-5 grid grid-cols-1 gap-4 md:grid-cols-2">
              <InputField
                props={{
                  id: "transport_name",
                  title: "Names Of Transportations",
                  type: "text",
                  value: transport_name || "",
                  onChange: (e) => {
                    set_transport_name(e.target.value);
                    setError(null);
                    setSuccess(null);
                  },
                }}
              />
            </div>
          </section>

          {/* STOCK MARKET */}
          <section className="rounded-2xl border border-gray-200 bg-white shadow-sm">
            <div className="border-b px-5 py-4">
              <h3 className="text-sm font-semibold text-gray-900">Stock Market</h3>
            </div>
            <div className="p-5 grid grid-cols-1 gap-4 md:grid-cols-2">
              <InputField props={{ id: "stock_market_name", title: "Stock Market Name", type: "text", value: stock_market_name || "", onChange: (e) => { set_stock_market_name(e.target.value); setError(null); setSuccess(null); } }} />
              <InputField props={{ id: "stock_market_index", title: "Stock Market Index", type: "text", value: stock_market_index || "", onChange: (e) => { set_stock_market_index(e.target.value); setError(null); setSuccess(null); } }} />
              <TextArea props={{ id: "stock_market_info", title: "Stock Market Info", type: "text", value: stock_market_info || "", onChange: (e) => { set_stock_market_info(e.target.value); setError(null); setSuccess(null); } }} />
            </div>
          </section>

          {/* CONNECTIVITY */}
          <section className="rounded-2xl border border-gray-200 bg-white shadow-sm">
            <div className="border-b px-5 py-4">
              <h3 className="text-sm font-semibold text-gray-900">Connectivity</h3>
            </div>
            <div className="p-5 grid grid-cols-1 gap-4 md:grid-cols-2">
              <InputField props={{ id: "tld", title: "Top Level Domain", type: "text", value: top_level_domain || "", onChange: (e) => { set_top_level_domain(e.target.value); setError(null); setSuccess(null); } }} />
              <InputField props={{ id: "internet_provider", title: "Internet Providers", type: "text", value: internet_providers || "", onChange: (e) => { set_internet_providers(e.target.value); setError(null); setSuccess(null); } }} />
              <InputField props={{ id: "internet_users", title: "Internet Users", type: "number", value: internet_users || "", onChange: (e) => { set_internet_users(e.target.value); setError(null); setSuccess(null); } }} />
              <InputField props={{ id: "mobile_phone", title: "Number Of Phones", type: "number", value: number_of_phones || "", onChange: (e) => { set_number_of_phones(e.target.value); setError(null); setSuccess(null); } }} />
            </div>
          </section>

          {/* DRIVING & SAFETY */}
          <section className="rounded-2xl border border-gray-200 bg-white shadow-sm">
            <div className="border-b px-5 py-4">
              <h3 className="text-sm font-semibold text-gray-900">Driving, Safety & Security</h3>
            </div>
            <div className="p-5 space-y-6">
              <div className="grid grid-cols-1 gap-4">
                <Select
                  props={{
                    id: "driving_side",
                    title: "Driving Side",
                    option: ["left", "right"],
                    preselect: country_driving_side ? [{ name: country_driving_side }] : null,
                    onChange: (e) => {
                      set_country_driving_side(e.target.value);
                      setError(null);
                      setSuccess(null);
                    },
                  }}
                />
              </div>

              <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
                <Select
                  props={{
                    id: "tourism",
                    title: "Tourism",
                    option: ["safe", "intermediate", "danger"],
                    preselect: tourism ? [{ name: tourism }] : null,
                    onChange: (e) => {
                      set_tourism(e.target.value);
                      setError(null);
                      setSuccess(null);
                    },
                  }}
                />
                <Select
                  props={{
                    id: "safety_indicator",
                    title: "Safety Indicator",
                    option: ["safe", "intermediate", "danger"],
                    preselect: safety_indicator ? [{ name: safety_indicator }] : null,
                    onChange: (e) => {
                      set_safety_indicator(e.target.value);
                      setError(null);
                      setSuccess(null);
                    },
                  }}
                />
              </div>
            </div>
          </section>

          {/* ELECTRICITY */}
          <section className="rounded-2xl border border-gray-200 bg-white shadow-sm">
            <div className="border-b px-5 py-4">
              <h3 className="text-sm font-semibold text-gray-900">Electricity</h3>
            </div>
            <div className="p-5 space-y-4">
              <div className="grid grid-cols-1 gap-4 md:grid-cols-3 lg:grid-cols-4">
                <InputField props={{ id: "voltage", title: "Voltage (V)", type: "number", value: voltage || "", onChange: (e) => { set_voltage(e.target.value); setError(null); setSuccess(null); } }} />
                <InputField props={{ id: "plug_standard", title: "Plug Standard", type: "text", value: plug_standard || "", onChange: (e) => { set_plug_standard(e.target.value); setError(null); setSuccess(null); } }} />
                <InputField props={{ id: "residential_voltage", title: "Residential Voltage", type: "text", value: residential_voltage || "", onChange: (e) => { set_residential_voltage(e.target.value); setError(null); setSuccess(null); } }} />
                <InputField props={{ id: "three_phase_voltage", title: "Three Phase Voltage", type: "text", value: three_phase_voltage || "", onChange: (e) => { set_three_phase_voltage(e.target.value); setError(null); setSuccess(null); } }} />
                <InputField props={{ id: "frequency", title: "Frequency", type: "text", value: frequency || "", onChange: (e) => { set_frequency(e.target.value); setError(null); setSuccess(null); } }} />
              </div>
              <TextArea
                props={{
                  id: "plug_note",
                  title: "Plug Note",
                  type: "text",
                  value: plug_note || "",
                  onChange: (e) => {
                    set_plug_note(e.target.value);
                    setError(null);
                    setSuccess(null);
                  },
                }}
              />
            </div>
          </section>

          {/* SOCIAL */}
          <section className="rounded-2xl border border-gray-200 bg-white shadow-sm">
            <div className="border-b px-5 py-4">
              <h3 className="text-sm font-semibold text-gray-900">Social & Web</h3>
            </div>
            <div className="p-5 grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-3">
              <InputField props={{ id: "website", title: "Website", type: "text", value: website || "", onChange: (e) => { set_website(e.target.value); setError(null); setSuccess(null); } }} />
              <InputField props={{ id: "youtube", title: "YouTube", type: "text", value: youtube || "", onChange: (e) => { set_youtube(e.target.value); setError(null); setSuccess(null); } }} />
              <InputField props={{ id: "facebook", title: "Facebook", type: "text", value: facebook || "", onChange: (e) => { set_facebook(e.target.value); setError(null); setSuccess(null); } }} />
              <InputField props={{ id: "twitter", title: "Twitter", type: "text", value: twitter || "", onChange: (e) => { set_twitter(e.target.value); setError(null); setSuccess(null); } }} />
              <InputField props={{ id: "instagram", title: "Instagram", type: "text", value: instagram || "", onChange: (e) => { set_instagram(e.target.value); setError(null); setSuccess(null); } }} />
              <InputField props={{ id: "pinterest", title: "Pinterest", type: "text", value: pinterest || "", onChange: (e) => { set_pinterest(e.target.value); setError(null); setSuccess(null); } }} />
              <InputField props={{ id: "tiktok", title: "TikTok", type: "text", value: tiktok || "", onChange: (e) => { set_tiktok(e.target.value); setError(null); setSuccess(null); } }} />
            </div>
          </section>

          {/* EASE OF BUSINESS */}
          <section className="rounded-2xl border border-gray-200 bg-white shadow-sm">
            <div className="border-b px-5 py-4">
              <h3 className="text-sm font-semibold text-gray-900">Ease Of Business</h3>
            </div>
            <div className="p-5 grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-3">
              <InputField props={{ id: "ease_of_doing_business_regional_ranking", title: "Regional Ranking", type: "number", value: ease_of_doing_business_regional || "", onChange: (e) => { set_ease_of_doing_business_regional(e.target.value); setError(null); setSuccess(null); } }} />
              <InputField props={{ id: "ease_of_doing_business_continent_ranking", title: "Continent Ranking", type: "number", value: ease_of_doing_business_continent || "", onChange: (e) => { set_ease_of_doing_business_continent(e.target.value); setError(null); setSuccess(null); } }} />
              <InputField props={{ id: "ease_of_doing_business_global_ranking", title: "Global Ranking", type: "number", value: ease_of_doing_business_global || "", onChange: (e) => { set_ease_of_doing_business_global(e.target.value); setError(null); setSuccess(null); } }} />
            </div>
          </section>

          {/* IMPORTS & EXPORTS */}
          <section className="rounded-2xl border border-gray-200 bg-white shadow-sm">
            <div className="border-b px-5 py-4">
              <h3 className="text-sm font-semibold text-gray-900">Imports & Exports</h3>
            </div>
            <div className="p-5 grid grid-cols-1 gap-4 md:grid-cols-2">
              <TextArea props={{ id: "exports_increase", title: "Exports Increase", type: "text", value: exports_increase?.toString?.() || "", onChange: (e) => { set_exports_increase(e.target.value); setError(null); setSuccess(null); } }} />
              <TextArea props={{ id: "exports_goods", title: "Exports Goods", type: "text", value: exports_goods?.toString?.() || "", onChange: (e) => { set_exports_goods(e.target.value); setError(null); setSuccess(null); } }} />
              <TextArea props={{ id: "main_export_partners", title: "Main Export Partners", type: "text", value: main_export_partners?.toString?.() || "", onChange: (e) => { set_main_export_partners(e.target.value); setError(null); setSuccess(null); } }} />
              <TextArea props={{ id: "imports_increase", title: "Imports Increase", type: "text", value: imports_increase?.toString?.() || "", onChange: (e) => { set_imports_increase(e.target.value); setError(null); setSuccess(null); } }} />
              <TextArea props={{ id: "imports_goods", title: "Imports Goods", type: "text", value: imports_goods?.toString?.() || "", onChange: (e) => { set_imports_goods(e.target.value); setError(null); setSuccess(null); } }} />
              <TextArea props={{ id: "main_import_partners", title: "Main Import Partners", type: "text", value: main_import_partners?.toString?.() || "", onChange: (e) => { set_main_import_partners(e.target.value); setError(null); setSuccess(null); } }} />
            </div>
          </section>

          {/* ASSOCIATIONS */}
          <section className="rounded-2xl border border-gray-200 bg-white shadow-sm">
            <div className="border-b px-5 py-4">
              <h3 className="text-sm font-semibold text-gray-900">
                Trade Organizations, Regional Blocks & Plug Types
              </h3>
            </div>
            <div className="p-5 grid grid-cols-1 gap-6">
              <TradeOrganizationCard
                trades={trades}
                tradesID={tradesID}
                setError={setError}
                setTrades={setTrades}
                setSuccess={setSuccess}
                setTradesID={setTradesID}
                setIsTradeChanges={setIsTradeChanges}
                localTradeOrganizations={localTradeOrganizations}
              />

              <RegionalBlocksCard
                blocks={blocks}
                blocksID={blocksID}
                setError={setError}
                setBlocks={setBlocks}
                setSuccess={setSuccess}
                setBlocksID={setBlocksID}
                setIsBlockChanges={setIsBlockChanges}
                localRegionalBlocks={localRegionalBlocks}
              />

              <PlugImageCard
                plugs={plugs}
                plugsID={plugsID}
                setError={setError}
                setPlugs={setPlugs}
                setPlugsID={setPlugsID}
                setSuccess={setSuccess}
                localPlugImages={localPlugImages}
                setIsPlugChanges={setIsPlugChanges}
              />
            </div>
          </section>

          {/* STATUS */}
          <section className="rounded-2xl border border-gray-200 bg-white shadow-sm">
            <div className="border-b px-5 py-4">
              <h3 className="text-sm font-semibold text-gray-900">Visibility</h3>
            </div>
            <div className="p-5 grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3">
              {countryStatus === 0 || countryStatus === 1 ? (
                <SelectInput
                  title="Status"
                  options={["visible", "invisible"]}
                  defaultValue={countryStatus === 1 ? "visible" : "invisible"}
                  onChange={(e) => {
                    if (e.target.value === "visible") setCountryStatus(1);
                    else setCountryStatus(0);
                    setError(null);
                    setSuccess(null);
                  }}
                />
              ) : null}
            </div>
          </section>

          {/* ACTIONS */}
          <div className="sticky bottom-0 z-10 mx-[-1rem] mb-[-1rem] mt-2 bg-gradient-to-t from-white/95 to-white/0 px-4 pt-6">
            <div className="mx-auto max-w-7xl flex justify-center">
              <MyActionButton
                loading={loading}
                title="Save Changes"
                onClick={() => {
                  setError(false);
                  setSuccess(false);
                  setErrorMessage(null);
                }}
              />
            </div>
          </div>
        </div>
      </form>
    </div>
  );
};

export default Edit;
